import RecoveryPasswordForm from "../../components/RecoveryPasswordForm";

const RecoveryPasswordPage = () => {
  return(
    <RecoveryPasswordForm />
  )
}

export default RecoveryPasswordPage;